import { TextWriter } from '@zip.js/zip.js';
/**
 * Converts a zip entry to an ItemData object.
 * @param entry - The zip file entry.
 * @returns An ItemData object with methods to retrieve the data in different formats.
 */
export function fileEntryToData(entry) {
    return {
        text: () => {
            return entry.getData(new TextWriter());
        },
        arrayBuffer: async () => {
            const stream = new TransformStream();
            const [buffer] = await Promise.all([
                new Response(stream.readable).arrayBuffer(),
                entry.getData(stream.writable),
            ]);
            return buffer;
        },
        stream: () => {
            const { writable, readable } = new TransformStream();
            /* v8 ignore start */
            // getData and writable are local, there is no easy way to force an error
            async function propagateErrorToStream(error) {
                await Promise.allSettled([
                    writable.abort(error),
                    readable.cancel(error),
                ]);
            }
            /* v8 ignore end */
            void entry.getData(writable).catch(propagateErrorToStream);
            return readable;
        },
    };
}
//# sourceMappingURL=file_entry_to_data.js.map